const avatarFormCompany = {
  logo: 'LOGO',
  Typography: 'wait for the file to upload'
};

export default avatarFormCompany;
